<template>
  <Modal
    title="批量导入"
    :value="visible"
    :maskClosable="false"
    @on-cancel="cancelHandler"
    footer-hide
  >
    <Form :label-width="110">
      <FormItem label="导入excel">
        <div>
          <input type="file" class="file-input" ref="fileInput" @change="uploadXlsx">
          <Button :loading="parsingFile" @click="$refs.fileInput.click()">上传</Button>
          <span class="knowledge-file-name">{{knowledgeData.name}}</span>
        </div>
        <a type="text" @click="downloadTemplate">下载模板</a>
      </FormItem>
      <FormItem label="导入录音">
        <upload
          ref="upload"
          class="upload"
          multiple
          :on-success="(_, __, fileList) => fileChange(fileList)"
          :on-remove="(_, fileList) => fileChange(fileList)"
        />
      </FormItem>
      <div class="flex flex-end">
        <Button type="primary" @click="handleSubmit">提交</Button>
        <Button @click="cancelHandler" style="margin-left: 8px">取消</Button>
      </div>
    </Form>
  </Modal>
</template>

<script>
import upload from '../../../components/upload.vue';
import XLSX from 'xlsx';
import { mapState, mapActions } from 'vuex'
import cloneDeep from 'lodash/cloneDeep'
import { addNodeId } from '@/utils/nodeIdPool';

// 文件操作
// 读取文件
function fileToWorkbook(file) {
  return new Promise((res, rej) => {
    const reader = new FileReader();
    reader.onload = (e) => {
      const data = new Uint8Array(e.target.result);
      const workbook = XLSX.read(data, {type: 'array'});
      res(workbook);
    };
    reader.onerror = (err) => {
      rej(err);
    }
    reader.readAsArrayBuffer(file);
  })
}

// 获取第一页数据
function getfirstSheet(workbook) {
  const first_sheet_name = workbook.SheetNames[0];
  return workbook.Sheets[first_sheet_name];
}

async function fileToJson(file) {
  if (!file) return Promise.reject('file is empty')
  const workbook = await fileToWorkbook(file);
  const worksheet = getfirstSheet(workbook);
  return XLSX.utils.sheet_to_json(worksheet)
}

// 默认数据
const defaultKnowledge = {
  type: '',
  name: '',
  key_words: '', // 这个没用了，暂时留着
  sentences: [],
  responses: [],
  action: '',
  action_data: '',
  tag: '',
  rate: 0,
  can_break: true,
  break_delay: 0,
  vars: [],
}

export default {
  components: { upload },
  model: {
    prop: 'visible',
    event: 'change'
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapState('setting', [
			'ratings',
    ]),
    ratingsMap() {
      const keys = Object.keys(this.ratings);
      return keys.reduce((value, key) => {
        value[this.ratings[key]] = ~~key;
        value[key] = ~~key;
        return value;
      }, {})
    }
  },
  data() {
    return {
      xlsxField: {
        类型: {
          key: 'type',
          format: (type) => {
            if (type === '常规' || type === '常规问题') return 'normal';
            if (type === '业务' || type === '业务问题') return 'bussiness';
            return '';
          }
        },
        标题: { key: 'name' },
        关键词: {
          key: 'sentences',
          format: (sentence) => {
            let sentences = []
            try {
              sentences = sentence.split(/(?<![\\]),/).map(item => item.replace(/\\,/g, ','));
            } catch (error) {
              sentences = [sentence]
            }
            const res = sentences.reduce((item, key) => {
              if (!key) return item;
              try {
                new RegExp(key)
                item.correct.push(key)
              } catch (error) {
                item.error.push(key)
              }
              return item;
            }, { correct: [], error: [] })
            return res.correct
          }
        },
        机器人回答文本: { key: 'text' },
        机器人回答录音文件名: { key: 'fileName' },
        // 评级: { key: 'rate', format: (rate) => this.ratingsMap[rate] },
        // 是否打断: { key: 'can_break', format: (canBreak) => canBreak === '是' },
      },
      parsingFile: false,
      parsingAudio: false,
      knowledgeData: {}, // excel 数据
      fileData: {}, // 录音数据
    };
  },
  methods: {
    ...mapActions('knowledge', ['saveKnowledges']),
    uploadXlsx(e) {
      this.parsingFile = true;
      const files = e.target.files, f = files[0];
      e.target.value = '';
      this.knowledgeData = {
        name: f.name,
        size: f.size,
        type: f.type,
        data: [],
      };
      fileToJson(f).then(sheetJson => {
        this.knowledgeData.data = this.formatData(sheetJson)
        this.parsingFile = false;
      }).catch(() => {
        this.parsingFile = false;
      })
    },
    // 格式化数据
    formatData(sheetJson = []) {
      return sheetJson.reduce((data, row) => {
        const rowData = this.getNeedData(row)
        // 数据校验
        if (!rowData.type || !rowData.name || rowData.sentences?.length <= 0) return data;
        data.push(rowData);
        return data;
      }, [])
    },
    // 单行中获取需要的数据
    getNeedData(row = {}) {
      return Object.keys(row).reduce((data, key) => {
        const field = this.xlsxField[key];
        if (!field || !field.key) return data;
        let value = `${row[key]}`.trim();
        if (field.format) {
          value = field.format(value);
        }
        // 目前导入的都是string
        data[field.key] = Array.isArray(value)? value : `${value}`;
        return data;
      }, cloneDeep(defaultKnowledge))
    },
    fileChange(fileList) {
      this.fileData = fileList.reduce((fileData, next) => {
        const filepath = next?.response?.data?.filepath;
        if (filepath) fileData[next.name] = filepath;
        return fileData;
      }, {})
    },
    // 提交
    handleSubmit() {
      this.saveKnowledges(this.knowledgeData?.data?.map(data => {
        const response = { text: '', voice: '', id: addNodeId('V') }
        if ('text' in data) {
          response.text = data.text;
          delete data.text;
        }
        if ('fileName' in data) {
          response.voice = this.fileData[data.fileName];
          delete data.fileName;
        }
        data.responses = [response]
        return data;
      }) || []);
      this.cancelHandler();
    },
    // 关闭
		cancelHandler() {
      this.$emit('change', false)
      this.$emit('cancel');
      this.knowledgeData = {};
      this.fileData = {};
      this.$refs.upload.clearFiles()
		},
    // 下载模板
    downloadTemplate() {
      const list = [['类型', '标题', '关键词', '机器人回答文本', '机器人回答录音文件名']];
      const worksheet = XLSX.utils.aoa_to_sheet(list);
      const newWorkbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(newWorkbook, worksheet, 'SheetJS');
      XLSX.writeFile(newWorkbook, '模板.xlsx');
    }
  }
}
</script>

<style lang="scss" scoped>
.file-input {
  display: none;
}
.upload {
  ::v-deep .ivu-upload-list {
    max-height: 250px;
    overflow-y: auto;
  }
}
.knowledge-file-name {
  margin-left: 12px;
  font-size: 12px;
}
</style>

